import React, { forwardRef } from 'react';
import {Progress} from 'antd';
import {
  StyledOverflowProgressContent,
  StyledOverflowProgressOverlay,
  StyledOverflowProgressWrapper,
  StyledOverflowProgressText
} from './StyledOverflowProgress';
import {colorsStyles} from '../../utils/styles';

const OverflowProgress = forwardRef((props, ref) => {
  const {
    percent = 0,
    overflowColor = colorsStyles.functional_danger,
    clampOverflow = true,
    style,
    className,
    hidePercent = false,
    ...rest
  } = props;

  const mainPercent = Math.min(Math.max(percent, 0), 100);
  const rawOverflow = Math.max(percent - 100, 0);
  const overflowPercent = clampOverflow
    ? Math.min(rawOverflow, 100)
    : rawOverflow; // user may allow >100 if desired

  const overlayStyle = {
    width: `${overflowPercent}%`,
    background: overflowColor,
    borderRadius: overflowPercent === 100 ? '6px' : '0 6px 6px 0',
  };

  const progressProps = {
    percent: mainPercent,
    showInfo: false,
    size: { width: 'default', height: 6 },
    strokeColor: colorsStyles.neutral_8
  }

  // If no overflow, render normal Progress for best compatibility with antd behavior.
  if (overflowPercent <= 0) {
    return (
      <StyledOverflowProgressWrapper style={style} className={className} ref={ref}>
        <Progress {...progressProps} {...rest} />
        {!hidePercent && (
          <StyledOverflowProgressText>
            {percent}%
          </StyledOverflowProgressText>
        )}
      </StyledOverflowProgressWrapper>
    );
  }

  // For overflow case: render a full (100%) progress as base and overlay the extra red from the right.
  return (
    <StyledOverflowProgressWrapper style={style} className={className} ref={ref}>
      <StyledOverflowProgressContent style={{ position: 'relative' }}>
        <Progress {...progressProps} {...rest} />
        <StyledOverflowProgressOverlay className='overflow-overbudget-progress' style={overlayStyle} aria-hidden='true' />
      </StyledOverflowProgressContent>
      {!hidePercent && (
        <StyledOverflowProgressText color={overflowColor}>
          {percent}%
        </StyledOverflowProgressText>
      )}
    </StyledOverflowProgressWrapper>
  );
});

export default OverflowProgress;
